// extracted by mini-css-extract-plugin
export var formContainer = "forms-module--formContainer--acba8";
export var formHeadline = "forms-module--formHeadline--71c6c";
export var formItem = "forms-module--formItem--0248c";
export var formWrapper = "forms-module--formWrapper--6339c";